import stringSimilarity from 'string-similarity';
import {
  ElementAllowedValues,
  SettingCategory,
  SettingName,
} from '../../models/countriesModel';
import { store } from '../../stores/store';

export const getSetting = (
  countryCode: string | undefined,
  category: SettingCategory,
  name: SettingName
): string | undefined => {
  const settings =
    store.shipmentCountriesStore.getSettingsOrDefault(countryCode);
  return settings?.find((s) => s.category === category && s.name === name)
    ?.value;
};

export const getSettingReceiverCountry = (
  countryCode?: string,
  isDomestic?: boolean
): string | undefined =>
  getSetting(
    countryCode,
    'delivery_options',
    isDomestic ? 'receiver_country_domestic' : 'receiver_country'
  );

export const findAdminUnitFromPrediction = (
  adminUnitKey: string,
  adminUnits: ElementAllowedValues[] | undefined | null
) => {
  const probabilities = adminUnits
    ?.map((unit) =>
      unit.keys
        .map((key) => {
          const probability = stringSimilarity.compareTwoStrings(
            key.toLocaleLowerCase().replace(' oblats', ''),
            adminUnitKey.toLocaleLowerCase().replace(' oblats', '')
          );
          return { value: unit.value, probability };
        })
        .flat()
    )
    .flat();

  return probabilities?.toSorted((a, b) => b.probability - a.probability)[0]
    .value;
};
